export const enviroment = {
  baseApi: "",
  baseUrl: "https://navigate.one/reclame-rio/#/",
};
